module.exports = {
  title: '创建/编辑奖励-优惠券',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'terrace-award-created',
    },
  },
};
